import { ListBase } from './../tools/ListBase';

class BusBases extends ListBase {

  constructor ({props, context}) {
    super();
    this.state = {rows: [], cls: 'busbases'};
    this.title = 'Bus Bases';
    this.state.columns = [
      {
        field: 'Nombre',
        headerName: 'Nombre',
        width: 250,
      },
      {
        field: 'Direccion',
        headerName: 'Dirección',
        width: 750,
      },
    ];

  }

}


import { useNavigate } from 'react-router-dom';

function BusBasesWithNavigate(props) {
  const navigate = useNavigate();
  return <BusBases {...props} navigate={navigate} />;
}

export default BusBasesWithNavigate;